<template>
  <div class="plateorder">
    <div class="plateorder-tabs vue_flex vue_flex_end vue_align_center">
      <div class="plateorder-tabs-input vue_flex vue_align_center">
        <!-- <div class="top_bar_inp vue_flex vue_align_center">
          <img
            class="top_bar_inp_img1 h"
            src="../../../../../assets/yimou/ss.png"
            alt=""
          />
          <input
            type="text"
            class="top_bar_inp_inp"
            v-model="searchValue"
            placeholder="店铺ID、名称关键字查询"
          />
        </div> -->
      </div>
      <div
        class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h"
        @click="dialogimportVisible = true"
      >
        创建店铺
      </div>
    </div>

    <div class="width_100" style="margin-top: 28px">
      <el-table
        :data="dataList"
        style="width: 100%"
        :header-cell-style="headercellstyle"
        border
        height="70vh"
        :key="'taobaoTable'"
      >
        <el-table-column
          prop="shopid"
          label="店铺ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="店铺名称"
          align="center"
        ></el-table-column>
        <el-table-column prop="type" label="店铺渠道" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.type == 1">淘宝</div>
            <div v-if="row.type == 2">京东</div>
            <div v-if="row.type == 3">拼多多</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="yewu"
          label="主营业务"
          align="center"
        ></el-table-column>

        <el-table-column label="操作" align="center" min-width="100px">
          <template slot-scope="scope">
            <div>
              <el-button @click="edithandle(scope.row)" type="primary"
                >编辑</el-button
              >
              <el-button @click="handleDelete(scope.row)" type="danger"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getListFun"
    />

    <el-dialog
      :visible.sync="dialogimportVisible"
      custom-class="unique-dialog"
      width="449px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="import-mask vue_flex vue_align_center vue_column">
        <div
          class="import-mask-title vue-font-PingFang-500 color_255 vue_relative"
        >
          {{ tempObj.id ? "编辑店铺" : "创建店铺" }}
          <img
            src="../../../../../assets/yimou/gb.png"
            alt=""
            class="vue_absolute h"
            @click="dialogimportVisible = false"
          />
        </div>
        <div class="import-mask-boxs vue_flex vue_column">
          <div class="import-mask-boxs-inp">
            <ul class="vue_flex vue_align_center">
              <li class="vue_flex vue-font-PingFang-500">
                <p class="color_35">店铺ID</p>
                <span>*</span>
              </li>
              <li class="import-mask-ul-boxs">
                <el-input v-model="tempObj.shopid"></el-input>
              </li>
            </ul>
          </div>
          <div class="import-mask-boxs-inp">
            <ul class="vue_flex vue_align_center">
              <li class="vue_flex vue-font-PingFang-500">
                <p class="color_35">店铺名称</p>
                <span>*</span>
              </li>
              <li class="import-mask-ul-boxs">
                <el-input v-model="tempObj.name"></el-input>
              </li>
            </ul>
          </div>
          <div class="import-mask-boxs-inp">
            <ul class="vue_flex vue_align_center">
              <li class="vue_flex vue-font-PingFang-500">
                <p class="color_35">渠道</p>
                <span>*</span>
              </li>
              <li class="import-mask-ul-boxs">
                <el-select v-model="tempObj.type" placeholder="请选择">
                  <el-option
                    v-for="item in qudaooptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input v-model="tempObj.type"></el-input> -->
              </li>
            </ul>
          </div>
          <div class="import-mask-boxs-inp">
            <ul class="vue_flex">
              <li class="vue_flex vue-font-PingFang-500">
                <p class="color_35">主营业务</p>
                <span>*</span>
              </li>
              <li class="import-mask-ul-boxs">
                <el-input
                  v-model="tempObj.yewu"
                  type="textarea"
                  :autosize="{ minRows: 2 }"
                ></el-input>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="import-mask-but vue-font-PingFang-500 color_255 h"
          @click="applyFun"
        >
          确认
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
  components: { Pagination },
  data() {
    return {
      qudaooptions: [
        { value: "1", label: "淘宝" },
        { value: "2", label: "京东" },
        { value: "3", label: "拼多多" },
      ],
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: "rgba(245, 247, 250, 1)",
        color: "rgba(51, 3, 0, 1)",
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },

      dialogimportVisible: false,

      wenzi: "",
      searchValue: "",
      dataList: [],
      options: [
        { value: "选项1", label: "黄金糕" },
        { value: "选项2", label: "双皮奶" },
        { value: "选项3", label: "蚵仔煎" },
        { value: "选项4", label: "龙须面" },
        { value: "选项5", label: "北京烤鸭" },
      ],
      tempObj: {
        type: "",
        shopid: "",
        name: "",
        yewu: "",
      },

      input: "",
    };
  },

  created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    this.getListFun();
  },

  methods: {
    // 删除
    async handleDelete(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await this.$http.get(this.$urls.delshop, { id: row.id });
          if (res.errcode != 0) return DonMessage.error(res.errmsg);
          DonMessage.success("删除成功");
          this.getListFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    edithandle(row) {
      this.tempObj = JSON.parse(JSON.stringify(row));
      console.log("edit--", this.tempObj);
      this.dialogimportVisible = true;
    },
    async applyFun() {
      if (this.tempObj.shopid == "") return DonMessage.error("请输入店铺ID");
      if (this.tempObj.name == "") return DonMessage.error("请输入店铺名称");
      if (this.tempObj.type == "") return DonMessage.error("请选择店铺渠道");
      if (this.tempObj.yewu == "")
        return DonMessage.error("请输入店铺主营业务");
      let url = this.tempObj.id ? this.$urls.editshop : this.$urls.addshop;

      const res = await this.$http.post(url, this.tempObj);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.tempObj.id
        ? DonMessage.success("编辑成功")
        : DonMessage.success("创建成功");
      this.tempObj = {
        type: "",
        shopid: "",
        name: "",
        yewu: "",
      };
      this.dialogimportVisible = false;
      this.getListFun();
    },
    async getListFun() {
      const res = await this.$http.get(this.$urls.getshoplist, this.listQuery);
      console.log("getListFun", res);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.dataList = res.list;
      this.total = res.count;
    },
  },
};
</script>

<style lang="scss" scoped>
.plateorder {
  padding: 22px;
}
.plateorder-tabs {
  background: rgba(245, 245, 245, 1);
  border-radius: 10px;
  padding: 9px 18px 8px 47px;
  .plateorder-tabs-input {
    .shaixuan_item {
      width: 350px;
      height: 54px;
      background: #ffffff;
      border-radius: 10px;
      padding: 0 20px;
      margin-right: 22px;
      .shaixuan_item_con {
        p {
          font-size: 18px;
        }
        .shaixuan_item_arr {
          width: 13px;
          height: 8px;
          margin-left: 10px;
        }
        .shaixuan_item_icon {
          width: 29px;
          height: 24px;
          margin-right: 10px;
        }
      }
    }

    .top_bar_inp {
      width: 372px;
      height: 54px;
      background: rgba(255, 255, 255, 1);
      border-radius: 10px;
      margin-right: 32px;
      padding: 0 11px;
      .top_bar_inp_img1 {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }
      .top_bar_inp_inp {
        width: 282px;
      }
    }
  }
  .plateorder-tabs-input-but {
    width: 131px;
    height: 54px;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 20px;
    line-height: 54px;
    text-align: center;
  }
}

.import-mask {
  width: 100%;
  border-radius: 15px;
  background-image: url("../../../../../assets/yimou/tb.png");
  background-size: 100% 51px;
  background-repeat: no-repeat;
  padding-bottom: 40px;
  .import-mask-title {
    width: 100%;
    height: 51px;
    line-height: 51px;
    text-align: center;
    font-size: 18px;
    img {
      width: 13px;
      height: 13px;
      top: 21px;
      right: 20px;
    }
  }
  .import-mask-boxs {
    width: 350px;
    margin-top: 40px;
    .import-mask-boxs-inp {
      width: 100%;
      background: rgba(245, 245, 245, 1);
      border-radius: 10px;
      padding: 11px 22px;
      margin-bottom: 19px;
      ul {
        li:nth-of-type(1) {
          width: 185px;
          font-size: 18px;
          line-height: 18px;
          span {
            color: rgba(255, 0, 0, 1);
          }
        }
      }
    }
    .import-mask-boxs-inp .el-input /deep/.el-input__inner {
      border: none !important;
      background: none !important;
      font-size: 18px;
    }
    .import-mask-boxs-inp .el-textarea /deep/.el-textarea__inner {
      border: none !important;
      background: none !important;
      font-size: 18px;
    }

    .import-mask-boxs-upload {
      width: 100%;
      height: 168px;
      margin: 10px 0px 34px;
      background-image: url("../../../../../assets/yimou/hsk.png");
      img {
        width: 35px;
        height: 31px;
        margin-top: 39px;
      }
      .upload-title {
        font-size: 16px;
        line-height: 16px;
        margin: 16px 0px 13px;
        span:nth-of-type(2) {
          color: rgba(20, 75, 201, 1);
        }
      }
      .upload-content {
        font-size: 14px;
        line-height: 14px;
      }
    }
    .import-mask-ul-boxs {
      width: 24vw;
    }
  }
  .import-mask-but {
    width: 266px;
    height: 47px;
    line-height: 47px;
    text-align: center;
    background: rgba(25, 92, 248, 1);
    border-radius: 10px;
    font-size: 17px;
  }
}

.plateorder-type {
  margin: 23px 0px;
  div {
    width: 155px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-radius: 10px;
    margin-right: 14px;
  }
  .active {
    color: rgba(255, 255, 255, 1);
    background: rgba(25, 92, 248, 1);
  }
  .activenot {
    color: rgba(35, 35, 35, 1);
    background: rgba(245, 245, 245, 1);
  }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
  border: none !important;
  font-size: 18px;
}
.revenbook-drawer .el-input /deep/.el-input__inner {
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select {
  width: 100% !important;
}
.el-select /deep/.el-input__inner {
  width: 100%;
  border: none !important;
  background: none !important;
  font-size: 18px;
}
.el-select /deep/.el-select__caret {
  color: #000000 !important;
}
.upload-demo /deep/.el-upload-dragger {
  background: none !important;
  border: none !important;
  border-radius: 0px !important;
  width: 640px !important;
  height: 168px;
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/shopmanage/shoplist/index.vue